// import { getToken } from '../utilities';

const PublicRoute = ({ children }) => {
    // const isLoggedIn = getToken() !== '';

    // if (isLoggedIn) {
    //     return <Navigate to={routePaths.home} />;
    // }

    return children;
};

export default PublicRoute;
